module.exports = __webpack_public_path__ + "assets/img/power.526a0187.png";